export const PROCEDURE = 'procedure';
export const PAYMENT = 'payment';
